import React, { useEffect, useState } from "react";
import FaqTable from "../inputComponents/FaqTable";

const ModalHSlidePrintout = (props) => {

  const [itemId, setItemId] = useState([]);
  const [general, setGeneral] = useState({
    salaryDate: null,
    referenceNo: null, 
    stamp: null,  
  });

  useEffect(() => {
    
    setGeneral((prev) => ({
      ...prev,
      salaryDate: props.datesUsed.startDate + " to " + props.datesUsed.endDate,
      referenceNo: props.referenceNo,
      
    }));
    setItemId(props.itemId);
 
  }, [props.datesUsed, props.referenceNo]);
  
  return (
    <>
      <div className="row m-1">
        <FaqTable general={general} itemId={itemId} />
      </div>
    </>
  );
};

export default ModalHSlidePrintout;
